"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = center;
function center(scale) {
  var offset = scale.bandwidth() / 2;
  if (scale.round()) offset = Math.round(offset);
  return function (d) {
    return scale(d) + offset;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/axis/build/utils/center.js
// module id = 1276
// module chunks = 0